(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  /* A-150: стрілки біля заголовка (мобайл) керують <lystia-carousel> секції через його API prev()/next() */
  (function () {
    function bind(sec) {
      if (sec._revNav) return; sec._revNav = true;
      const car = sec.querySelector('lystia-carousel'); const track = car && car.querySelector('.carousel__track');
      const prev = sec.querySelector('[data-rev-prev]'); const next = sec.querySelector('[data-rev-next]');
      if (!car || !track || !prev || !next) return;
      const step = (d) => (d > 0 ? car.next() : car.prev());
      const upd = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      prev.addEventListener('click', () => step(-1)); next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true }); upd();
    }
    const run = () => document.querySelectorAll('.home-reviews').forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tube"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lystia-tube-add')) {
    class LystiaTubeAdd extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('button[data-variant-id]');
          if (!btn || btn.classList.contains('is-loading')) return;
          const id = Number(btn.dataset.variantId);
          const toast = (text, icon) => document.lystiaToast && document.lystiaToast.show(text, { icon: icon });
          if (!id || !window.LystiaCart) return;
          btn.classList.add('is-loading');
          window.LystiaCart.add({ id: id, quantity: 1 })
            .then(() => toast(this.dataset.textAdded, 'check'))
            .catch(() => toast(this.dataset.textFailed, 'alert'))
            .finally(() => btn.classList.remove('is-loading'));
        });
      }
    }
    customElements.define('lystia-tube-add', LystiaTubeAdd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lystia-reviews')) {
    class LystiaReviews extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        const q = new URLSearchParams(window.location.search);
        const step = Number(this.dataset.step) || 6;
        this.step = step;
        this.panels = Array.from(this.querySelectorAll('[data-rv-scope]'));
        this.known = new Set(this.panels.map((el) => el.dataset.rvScope));
        this.cards = Array.from(this.querySelectorAll('[data-rv-card]'));
        this.chips = Array.from(this.querySelectorAll('[data-rv-stars]'));
        this.grid = this.querySelector('[data-rv-grid]');
        this.moreBtn = this.querySelector('[data-rv-more]');
        this.emptyBox = this.querySelector('[data-rv-empty]');
        this.emptyWrite = this.querySelector('[data-rv-empty-write]');
        this.select = this.querySelector('[data-rv-select]');
        this.selLabel = this.querySelector('[data-rv-sel-label]');
        this.dd = this.querySelector('[data-rv-dd]');
        const wanted = q.get('product') || 'all';
        this.state = { scope: wanted, stars: '', tea: '', shown: step };
        this.forceEmpty = q.get('state') === 'empty';
        this.addEventListener('click', (e) => {
          const chip = e.target.closest('[data-rv-stars]');
          if (chip) {
            this.state.stars = chip.dataset.rvStars;
            this.state.shown = this.step;
            this.render();
            return;
          }
          if (e.target.closest('[data-rv-more]')) {
            this.state.shown += this.step;
            this.render();
          }
        });
        if (this.select) {
          this.select.addEventListener('change', () => {
            this.state.tea = this.select.value;
            this.state.shown = this.step;
            this.render();
          });
        }
        this.render();
        this.dataset.ready = '';
      }

      render() {
        const s = this.state;
        const hasData = !!this.grid;
        const scope = this.known.has(s.scope) ? s.scope : 'all';
        const empty = this.forceEmpty || !hasData || !this.known.has(s.scope);
        this.dataset.scope = scope;
        this.panels.forEach((el) => {
          const on = el.dataset.rvScope === scope && (el.dataset.rvPart === 'top' || !empty);
          el.hidden = !on;
        });
        if (this.grid) this.grid.hidden = empty;
        if (this.emptyBox) this.emptyBox.hidden = !empty;
        if (this.emptyWrite) {
          if (scope !== 'all') this.emptyWrite.setAttribute('data-review-handle', scope);
          else this.emptyWrite.removeAttribute('data-review-handle');
        }
        if (!empty) {
          const tea = scope === 'all' ? s.tea : '';
          const match = this.cards.filter((c) => (scope === 'all' || c.dataset.rvProduct === scope) && (!s.stars || c.dataset.rvRating === s.stars) && (!tea || c.dataset.rvProduct === tea));
          const set = new Set(match.slice(0, s.shown));
          this.cards.forEach((c) => { c.hidden = !set.has(c); });
          if (this.moreBtn) this.moreBtn.hidden = match.length <= s.shown;
          this.chips.forEach((chip) => {
            const on = chip.dataset.rvStars === s.stars;
            chip.classList.toggle('is-active', on);
            chip.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (this.select && this.selLabel) {
            this.select.value = tea;
            this.selLabel.textContent = tea ? this.select.options[this.select.selectedIndex].text : (this.dataset.labelProduct || '');
            if (this.dd) this.dd.classList.toggle('is-active', !!tea);
          }
        }
        const top = this.panels.find((el) => el.dataset.rvScope === scope && el.dataset.rvPart === 'top');
        if (top && top.dataset.title && scope !== 'all') document.title = top.dataset.title;
      }
    }
    customElements.define('lystia-reviews', LystiaReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lystia-pdp-related')) {
    class LystiaPdpRelated extends HTMLElement {
      connectedCallback() {
        if (this._done) return;
        this._done = true;
        const tpl = this.querySelector('template[data-rel-pool]');
        const track = this.querySelector('[data-rel-track]');
        if (!tpl || !track) return;
        const slots = Array.from(track.querySelectorAll('[data-rel-item]'));
        const cards = slots.map((s) => s.querySelector('.pcard')).filter(Boolean);
        tpl.content.querySelectorAll('.pcard').forEach((c) => cards.push(document.importNode(c, true)));
        const count = Number(this.dataset.count) || 4;
        for (let i = cards.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        const picks = cards.slice(0, count).map((c) => c.cloneNode(true));
        slots.slice(0, count).forEach((slot, i) => {
          const old = slot.querySelector('.pcard');
          if (picks[i] && old) old.replaceWith(picks[i]);
        });
        if (window.LystiaFavorites && typeof window.LystiaFavorites.syncAll === 'function') window.LystiaFavorites.syncAll();
      }
    }
    customElements.define('lystia-pdp-related', LystiaPdpRelated);
  }

  } catch(e) { console.error(e); }
})();
})();
